import { differenceInDays } from 'date-fns';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Users } from '@sorare/core/src/atoms/icons/Users';
import { OnboardingHighlightWrapper } from '@sorare/core/src/components/onboarding/OnboardingHighlightWrapper';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';
import { glossary } from '@sorare/core/src/lib/glossary';

import { InviteButtonFTUE } from '../InviteButtonFTUE';
import { InviteDialog } from '../InviteDialog';

export const InviteButton = () => {
  const { currentUser } = useCurrentUserContext();
  const { lifecycle, update: updateLifecycle } = useLifecycle();
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);

  const isAccountOlderThan7Days =
    !!currentUser?.createdAt &&
    differenceInDays(new Date(), currentUser.createdAt) > 5;
  const sawInviteFriendsFTUE = !!lifecycle?.[LIFECYCLE.sawInviteFriendsFTUE];

  return (
    <>
      <OnboardingHighlightWrapper
        highlightName="InviteButton"
        config={{ padding: 4, borderRadius: 'var(--unit)' }}
        wrap={Boolean(isAccountOlderThan7Days && !sawInviteFriendsFTUE)}
      >
        <Button
          size="compact"
          color="tertiary"
          onClick={() => {
            setInviteDialogOpen(true);
            updateLifecycle(LIFECYCLE.sawInviteFriendsFTUE, true);
          }}
          startIcon={<Users />}
        >
          <FormattedMessage {...glossary.invite} />
        </Button>
      </OnboardingHighlightWrapper>
      <InviteButtonFTUE />
      {!!inviteDialogOpen && (
        <InviteDialog
          open
          onClose={() => {
            setInviteDialogOpen(false);
          }}
        />
      )}
    </>
  );
};
